import React from 'react';
import Responses from './SearchResponses';
import { useFreeUser } from 'v2/hooks/useFreeUser';
import { SearchEntity } from 'v2/models';
import { FreeSearchResponses } from './FreeSearchResponses/FreeSearchResponses';

interface SearchResponsesSwitchProps {
  search: SearchEntity;
}

export const SearchResponsesSwitch = ({
  search,
}: SearchResponsesSwitchProps) => {
  const [isFreeUser] = useFreeUser();
  return isFreeUser ? (
    <FreeSearchResponses search={search} />
  ) : (
    <Responses search={search} />
  );
};
